import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { stats, testimonials } from '@/mocks/data';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6 text-center">
              关于韩漫之家
            </h1>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base text-center max-w-3xl mx-auto mb-12">
              韩漫之家是专业的韩漫下载安装与韩漫离线免费下载平台，
              致力于为广大韩漫爱好者提供最便捷的韩漫APK获取渠道和最佳的韩漫阅读体验。
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-16">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-xl p-5 text-center border border-background-200/70"
                >
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500">
                    {stat.suffix} {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                品牌故事
              </h2>
              <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  韩漫之家成立于2020年，团队由一群热爱韩国漫画的年轻人组成。
                  我们发现国内韩漫爱好者常常面临找资源难、下载不便、阅读体验差等问题，
                  于是决定打造一个专业的韩漫下载平台。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  经过多年的发展，韩漫之家已经积累了超过10,000部韩漫资源，
                  覆盖恋爱、奇幻、热血、搞笑、悬疑、剧情、校园、BL等八大分类，
                  累计服务超过50万活跃用户，成为国内领先的韩漫下载平台。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  我们的使命是让每一位韩漫爱好者都能轻松获取优质的韩漫资源，
                  无论何时何地，都能畅享韩漫世界的精彩。韩漫之家将持续优化产品体验，
                  丰富内容资源，为韩漫文化的传播贡献力量。
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
                {testimonials.map((t) => (
                  <div
                    key={t.id}
                    className="bg-background-100 rounded-xl p-5 border border-background-200/70"
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                        <i className={`${t.avatar} text-primary-500 text-lg`}></i>
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-foreground-900">
                          {t.name}
                        </div>
                        <div className="flex items-center gap-0.5 mt-0.5">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <i
                              key={i}
                              className={`text-xs ${
                                i < t.rating
                                  ? 'ri-star-fill text-yellow-500'
                                  : 'ri-star-line text-foreground-300'
                              }`}
                            ></i>
                          ))}
                        </div>
                      </div>
                      <span className="ml-auto text-xs text-foreground-400 whitespace-nowrap">
                        {t.date}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {t.content}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-wechat-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  微信公众号
                </h3>
                <p className="text-xs text-foreground-500">韩漫之家</p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  电子邮箱
                </h3>
                <p className="text-xs text-foreground-500">
                  contact@hanmanzhijia.com
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-customer-service-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  客服时间
                </h3>
                <p className="text-xs text-foreground-500">每天 9:00 - 21:00</p>
              </div>
            </div>

            <div className="mt-10 text-center">
              <Link
                to="/article/5"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
                立即下载韩漫APK
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于韩漫之家',
            description:
              '韩漫之家是专业的韩漫下载安装与韩漫离线免费下载平台。',
            url: 'https://hanmanzhijia.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫之家',
              url: 'https://hanmanzhijia.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://hanmanzhijia.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}